import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import "modules/KeyLockersDashboard/components/CreateEditKeyLockerModal/components/PrivateKeyModal/PrivateKeyModal.scss";
import { handleCopyToClipboard } from "modules/ManufacturerDashboard/utils";

type PrivateKeyModalProps = {
  isOpen: boolean;
  privateKey?: string;
  onClose: () => void;
};

export const PrivateKeyModal = ({ isOpen, onClose, privateKey }: PrivateKeyModalProps) => {
  const { t } = useTranslation();

  if (!privateKey) return null;

  return (
    <Modal open={isOpen} closeOnDimmerClick onClose={onClose} className="PrivateKeyModal">
      <Modal.Header className="header-container">
        <div className="header-button-container">
          {t("v8_private_key", "Private Key")}
          <Button className="modal-close-btn" basic onClick={onClose}>
            <Icon className="xmark" />
          </Button>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className="content-container">
          <span className="text">{t("v8_this_key_will_be_displayed_only_once", "This key will be displayed only once, make sure to copy it and proceed to setup.")}</span>

          <div className="private-key" onClick={() => handleCopyToClipboard(privateKey, t("v8_private_key_copied", "Private key copied"))}>
            <Icon name="copy outline" className="green" />
            <span>{privateKey}</span>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};
